module.exports = __webpack_public_path__ + "img/52114118_L.7213a0b2.png";